import { FC } from 'react';
import { useSelector } from 'react-redux';
import { InlineFilter } from 'shared/components/InlineFilter';
import { RangeInput } from 'shared/components/RangeInput';
import { useDebouncedCallback, useFilterChangeCallback } from 'shared/hooks';
import { selectConstructionYearFilter } from 'shared/selectors/advancedFilters';

export const FlatOldConstructionYearContainer: FC = () => {
  const {
    value: { min: valueMin, max: valueMax },
    min,
    max,
  } = useSelector(selectConstructionYearFilter);

  const onChange = useFilterChangeCallback();

  const handleMinValueChange = useDebouncedCallback((value: number | null) => {
    onChange({ action: 'setConstructionYearMin', arguments: [value] });
  });

  const handleMaxValueChange = useDebouncedCallback((value: number | null) => {
    onChange({ action: 'setConstructionYearMax', arguments: [value] });
  });

  return (
    <InlineFilter width={100}>
      <RangeInput
        min={min}
        max={max}
        valueMin={valueMin}
        thousandsSeparator=""
        valueMax={valueMax}
        onChangeMin={handleMinValueChange}
        onChangeMax={handleMaxValueChange}
      />
    </InlineFilter>
  );
};
